import { useState, useEffect } from "react";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import CardSeplag from "../../../components/CardSeplag";
import { buscarExercicio, buscarParametroExercicio } from "../../../service/Rag/Exercicio";
import ModalRagExercicios from "./modalRagExercicios";
import Cronograma from "./cronograma";
import { useSelector } from "react-redux";
import { Skeleton } from "primereact/skeleton";

const RagCadastroExercicios = () => {
  const count = useSelector((state) => state.counterRequestReducer.counterRequest);
  const isLoading = count > 0;
  const [exercicioVisible, setExercicioVisible] = useState(true);
  const [cronogramaVisible, setCronogramaVisible] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [parametroExercicios, setParametroExercicios] = useState();
  const [exercicios, setExercicios] = useState([]);
  const [exercicio, setExercicio] = useState([]);
  const [edit, setEdit] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [atualizarExercicio, setAtualizarExercicio] = useState(true);

  const handleShowModal = () => {
    setVisibleModal(true);
    setExercicio(null);
    setEdit(false);
  };

  const actionTemplate = (node, _rowData) => {
    let verCronograma;
    let editarExercicio;
    let vizualizarExercicio;
    verCronograma = (
      <Button
        type="button"
        icon="pi pi-bars"
        className="p-button-success"
        style={{ marginRight: ".5em" }}
        tooltip="Ver Cronogramas"
        onClick={() => {
          showCronograma(node);
        }}
      />
    );

    editarExercicio = (
      <Button
        type="button"
        icon="pi pi-pencil"
        className="p-button-warning"
        style={{ marginRight: ".5em" }}
        onClick={() => editExercicio(node)}
      ></Button>
    );

    vizualizarExercicio = (
      <Button
        type="button"
        icon="pi pi-eye p-button-icon"
        className="p-button-help p-button p-component p-button-icon-only"
        onClick={() => showExercicio(node)}
      ></Button>
    );

    return (
      <div>
        {verCronograma}
        {editarExercicio}
        {vizualizarExercicio}
      </div>
    );
  };
  const editExercicio = (_exercicio) => {
    setExercicio({ ..._exercicio });
    setEdit(true);
    setVisibleModal(true);
  };

  const showExercicio = (_exercicio) => {
    setExercicio({ ..._exercicio });
    setEdit(true);
    setDisabled(true);
    setVisibleModal(true);
  };

  const showCronograma = (_exercicio) => {
    setExercicio(_exercicio);
    setExercicioVisible(false);
    setCronogramaVisible(true);
  };

  const habilitadoOrDesabilitado = (node) => {
    return node.flagAtivo === "S" ? "Sim" : "Não";
  };

  const header = (
    <div className="table-header">
      <Button
        type="button"
        onClick={() => {
          handleShowModal();
        }}
      >
        <span className="pi pi-check p-button-icon p-button-icon-left"></span>
        <span className="p-button-label">Habilitar Exercício</span>
      </Button>
    </div>
  );

  const TableLoader = (props) => {
    const products = Array.from({ length: 10 });
    const skeletonTemplate = () => {
      return <Skeleton></Skeleton>;
    };
    return (
      <CardSeplag title="Cadastro de Exercícios RAG">
        <DataTable header={header} value={products} responsiveLayout="scroll" className="p-datatable-striped">
          <Column header="Exercício" body={skeletonTemplate} style={{ width: "30%" }}></Column>
          <Column header="Ativo" body={skeletonTemplate} style={{ width: "20%" }}></Column>
          <Column header="Cronograma" body={skeletonTemplate} style={{ width: "30%" }}></Column>
          <Column header="Ação" body={skeletonTemplate} style={{ width: "20%" }}></Column>
        </DataTable>
      </CardSeplag>
    );
  };

  useEffect(() => {
    if (exercicioVisible === true && atualizarExercicio === true) {
      buscarExercicio().then((res) => {
        setExercicios(res.data);
      });

      buscarParametroExercicio().then((res) => {
        setParametroExercicios(res.data);
      });

      setAtualizarExercicio(false);
    }
  }, [exercicioVisible, atualizarExercicio]);

  if (isLoading && !cronogramaVisible && !visibleModal) {
    return <TableLoader />;
  }
  return (
    <>
      {exercicioVisible && (
        <div className="datatable">
          <CardSeplag title="Cadastro de Exercícios RAG">
            <DataTable
              header={header}
              value={parametroExercicios}
              stripedRows
              responsiveLayout="scroll"
              emptyMessage="Nenhum registro encontrado"
              sortField="exercicio.ano"
              sortOrder={-1}
            >
              <Column field="exercicio.ano" header="Exercício" style={{ width: "30%" }}></Column>

              <Column
                field="flagAtivo"
                body={habilitadoOrDesabilitado}
                header="Ativo"
                style={{ width: "20%" }}
              ></Column>
              <Column header="Cronograma" style={{ width: "30%" }}></Column>
              <Column body={actionTemplate} field="action" header="Ação" style={{ width: "20%" }}></Column>
            </DataTable>
            {visibleModal && (
              <ModalRagExercicios
                edit={edit}
                disabled={disabled}
                exercicio={exercicio}
                exercicios={exercicios}
                parametroExercicios={parametroExercicios}
                visible={visibleModal}
                setVisible={setVisibleModal}
                setEdit={setEdit}
                setDisabled={setDisabled}
                setAtualizarExercicio={setAtualizarExercicio}
              />
            )}
          </CardSeplag>
        </div>
      )}
      {cronogramaVisible && (
        <Cronograma
          exercicio={exercicio}
          setCronogramaVisible={setCronogramaVisible}
          setExercicioVisible={setExercicioVisible}
        />
      )}
    </>
  );
};
export default RagCadastroExercicios;
